import { render } from "./Footer.vue?vue&type=template&id=08a70b03&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=08a70b03&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a70b03"]])

export default __exports__